import BaseModal from "../../components/BaseModal";
import { MODAL_TYPES } from "../../utils/emitter";
import BaseButton from "../../components/BaseButton";
import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import useModalActions from "../../hooks/useModalActions";
import "./style.scss";

export default function RestoreDemoProgressModal({
  resetGameProgress,
  onRestoreGameHistory,
}) {
  RestoreDemoProgressModal.propTypes = {
    resetGameProgress: PropTypes.func,
    onRestoreGameHistory: PropTypes.func,
  };
  const { t } = useTranslation();
  const { closeModal } = useModalActions();
  return (
    <BaseModal
      className="modal-demo-progress"
      preventClose
      title={t("modals.restore_demo_progress.title")}
      eventTypeModal={MODAL_TYPES.RESTORE_DEMO_PROGRESS}
    >
      <BaseButton
        onClick={() => {
          closeModal(MODAL_TYPES.RESTORE_DEMO_PROGRESS);
        }}
      >
        {t("yes")}
      </BaseButton>
      <BaseButton
        unfilledWhite
        onClick={async () => {
          await resetGameProgress();
          await onRestoreGameHistory({ isRestore: true });
          closeModal(MODAL_TYPES.RESTORE_DEMO_PROGRESS);
        }}
        className="modal-button-cancel"
      >
        {t("no")}
      </BaseButton>
    </BaseModal>
  );
}
